import React, { useState, createRef } from 'react';
import {
  Stack, Container, Row, Col, Button,
} from 'react-bootstrap';
import ContactInput from './ContactInput';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
  setContacts,
} from '../features/signup/signupSlice';
import OrderSummary from './OrderSummary';
import { selectCommunityFibreEnabled } from '../features/featureFlags/featureFlagsSlice';

export interface DetailProps {
  onSubmit: any
  previousStep: any
  formState: any
  register: any
  getValues: any
  setValue: any
  handleSubmit: any
}

const ContactDetails = ({
  onSubmit, previousStep, formState, register, handleSubmit, getValues, setValue,
}: DetailProps) => {
  const dispatch = useAppDispatch();
  const communityFibreEnabled = useAppSelector(selectCommunityFibreEnabled);

  const next = handleSubmit((values: any) => {
    dispatch(setContacts({
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      howDidYouHearAboutUs: values.howDidYouHearAboutUs,
    }));
    onSubmit();
  });

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col>
          <h1 className="fw-bold text-primary text-center mb-4">
            Now let&apos;s get you set up!
          </h1>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <ContactInput
            formState={formState}
            register={register}
            getValues={getValues}
            setValue={setValue}
          />
        </Col>
        <Col>
          <OrderSummary />
        </Col>
      </Row>
      {communityFibreEnabled ? (
        // No top margin: the form ends with 1.5rem of space, the same as
        // the my-4 above the buttons.
        <Row className="justify-content-center">
          <Col md={6}>
            <p className="text-center mb-0">
              We&apos;ll save your progress so we can help you finish if you
              don&apos;t complete your order today. This includes your name,
              email and mobile number.
            </p>
          </Col>
        </Row>
      ) : null}
      <Stack
        gap={2}
        className="justify-content-center my-4"
        direction="horizontal"
      >
        <Button
          id="contact_info_go_back"
          onClick={previousStep}
          size="lg"
          variant="outline-primary"
        >
          <span className="px-2">Go back</span>
        </Button>
        <Button
          id="contact_info_continue"
          onClick={next}
          size="lg"
          variant="primary"
          disabled={formState.isValidating}
        >
          <span className="px-2">{formState.isValidating ? "Loading..." : "Continue"}</span>
        </Button>
      </Stack>
    </Container>
  );
};

export default ContactDetails;
